import { DatePipe } from '@angular/common';
import { Component, computed, inject, input, output } from '@angular/core';
import { MatMenuModule } from '@angular/material/menu';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faArrowRight, faEllipsisVertical, faTrashCan } from '@fortawesome/pro-regular-svg-icons';

import { UiAdminModule } from '@eiq/ui';
import { Language, LanguageCodePipe, Translation } from '@empathy/survey-core';

import { TranslationTabs } from '../../../models/translations/translation-tabs.enum';
import { EditorTranslationsService } from '../../../services/editor-translations.service';
import { TranslationsStatusComponent } from '../translations-status/translations-status.component';

@Component({
  standalone: true,
  selector: 'empathy-language-list-item',
  templateUrl: 'language-list-item.component.html',
  styleUrls: ['language-list-item.component.scss'],
  imports: [DatePipe, FontAwesomeModule, LanguageCodePipe, MatMenuModule, TranslationsStatusComponent, UiAdminModule]
})
export class LanguageListItemComponent {
  language = input.required<Language>();
  translation = input.required<Translation>();
  remove = output();

  // Required first because the following field initializers depend on it.
  /* eslint-disable @typescript-eslint/member-ordering */
  private readonly translationsService = inject(EditorTranslationsService);

  translatedPercent$ = computed(() => this.translationsService.translatedPercentage(this.translation()));

  faArrowRight = faArrowRight;
  faEllipsisVertical = faEllipsisVertical;
  faTrashCan = faTrashCan;

  onTranslate(): void {
    this.translationsService.setActiveLanguage(this.language().code);
    this.translationsService.activeTabIndex$.set(TranslationTabs.Translations);
  }
}
